function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "64",
  height: "64",
  viewBox: "0 0 64 64",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M24 0c13.255 0 24 10.745 24 24a23.89 23.89 0 01-4.437 13.906L62.607 56.95a4 4 0 11-5.657 5.657L37.906 43.563A23.89 23.89 0 0124 48C10.745 48 0 37.255 0 24S10.745 0 24 0zm0 8C15.163 8 8 15.163 8 24s7.163 16 16 16 16-7.163 16-16S32.837 8 24 8z",
  fill: "#2071BD",
  fillRule: "evenodd"
})));